import VideoModalQuiz from '@containers/IQOSUniverse/components/VideoModalQuiz/VideoModalQuiz';
export default VideoModalQuiz;
